import { ButtonVariant } from "@amzn/stencil-react-components/button";
import { Flyout, FlyoutContent } from "@amzn/stencil-react-components/flyout";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { TaxonomyIdItem } from "@amzn/taxonomy-lib";
import Button from "@amzn/uxm-stencil-react-components/lib/src/stencil/button";
import { getString } from "common/uistringlabels/uiStringUtils";
import { FeedbackStats } from "lib/services/catalogical-models";
import { CatalogicalDomain } from "lib/services/catalogical-service";
import React, { FC } from "react";

import { StarDetailedRating, StarDetailedRatingSize } from "../Ratings";
import { ProductReviewsList } from "./ProductReviewsList";

export interface ProductReviewsFlyoutProps {
  titleText: string;
  productName: string;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenWriteReviewFlyout: React.Dispatch<React.SetStateAction<boolean>>;
  feedback: FeedbackStats | undefined;
  taxonomyId: TaxonomyIdItem;
  domain: CatalogicalDomain;
}

export const ProductReviewsFlyout: FC<ProductReviewsFlyoutProps> = ({
  titleText,
  productName,
  isOpen,
  setIsOpen,
  setOpenWriteReviewFlyout,
  feedback,
  taxonomyId,
  domain,
}) => {
  const close = () => {
    setIsOpen(false);
  };

  const renderRating = () => {
    return (
      <Row justifyContent="space-between" style={{ paddingRight: "24px" }}>
        <View width={"50%"}>
          <StarDetailedRating
            size={StarDetailedRatingSize.Small}
            averageRating={feedback?.averageRating}
            voteNumber={feedback?.numberOfRatings}
            ratingCounts={feedback?.ratingCounts}
          />
        </View>
        <View display="flex" alignItems="flex-end" width={"30%"}>
          <Button
            variant={ButtonVariant.Primary}
            onClick={() => {
              setOpenWriteReviewFlyout(true);
              close();
            }}
            data-test-id="product-reviews-write-review-button"
            touchpoint="product-reviews-write-review"
          >
            {getString("productReviews.writeReview")}
          </Button>
        </View>
      </Row>
    );
  };

  const renderReviewsList = () => {
    return <ProductReviewsList taxonomyId={taxonomyId} domain={domain} />;
  };

  return (
    <Flyout isOpen={isOpen} close={close} dataTestId="product-reviews-flyout">
      <FlyoutContent onCloseButtonClick={close} titleText={titleText}>
        <Col width={"544px"} rowGap={"20px"}>
          <Text fontWeight={"bold"}>{productName}</Text>
          {renderRating()}
          {renderReviewsList()}
        </Col>
      </FlyoutContent>
    </Flyout>
  );
};
